import { render, staticRenderFns } from "./accountBillChild.vue?vue&type=template&id=abc6d204"
import script from "./accountBillChild.vue?vue&type=script&lang=js"
export * from "./accountBillChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports